import Box from '@mui/material/Box';
import { Outlet as RouterOutlet } from 'react-router';

export const Outlet = () => {
  return (
    <Box
      sx={{
        backgroundColor: 'background.default',
        flexGrow: 1,
        height: '100vh',
        overflowY: 'auto',
        overflowX: 'hidden',
      }}
    >
      <Box sx={{ px: 3, pb: 3, pt: 'calc(57px + 24px)' }}>
        <RouterOutlet />
      </Box>
    </Box>
  );
};
